import React, { Component } from 'react'
import { Select, Tag } from 'antd';
import { RESTExecutor, withDomains } from '../domain';
import { showErrorInNotification } from '../util';
import lodash from 'lodash';

class NetworkSelect extends Component {
    constructor(props) {
      super(props)
    
      this.state = {
         list_data:[],
         loading:false,
         prevParams:{}
      };

      this.list_items=RESTExecutor.list().config({
          url:props.url,
          params:{
              pagination:false
          }
      }).callbacks((success)=>{
          this.setState({list_data:success.result.rows})
      },(error)=>{
          showErrorInNotification(error);
      }).connect(props.domains.dynamic);


    };
    
    render() {
        let item=this.props.item||{};

        let value=this.props.value==null?undefined:this.props.value;
        console.log("VALUE IS",value)

        const {loading,list_data}=this.state;
        // console.log("network props",this.props)

        return (
            <Select
            style={{
                width:item.width||'100%',
                ...this.props.style
            }}
            className={item.className}
            value={value}
            allowClear
            showSearch={true}
            tagRender={(props)=>{
            return  <Tag className='tag-orange'  {...props}>{props.label}</Tag>
            }}
            filterOption={(input, option)=>{
                return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }}
            loading={loading}
            mode={item.mode||'default'}
            placeholder={item.name||"Select Option"}
            onChange={(value=null,option)=>{
                console.log("onchange",value,option)
            typeof this.props.onChange==='function'&&this.props.onChange(value||null);
            }}
            >
                {Array.isArray(list_data)&&list_data.map((_list_item)=>{
                    let list_item=_list_item;
                    if(typeof _list_item==='string'){
                        list_item={
                            id:_list_item,
                            name:_list_item
                        }
                    }
                    return <Select.Option 
                    title={item.display_key?(list_item[item.display_key]||""):(list_item.name||list_item.id)}
                    data={list_item}
                    key={`${item.item_key?list_item[item.item_key]:list_item.id}`} 
                    value={`${item.item_key?list_item[item.item_key]:list_item.id}`}>

                    {typeof this.props.renderItem==='function'?this.props.renderItem(list_item):
                    item.display_key?(list_item[item.display_key]||""):(list_item.name||list_item.id)
                    }

                    </Select.Option>
                })}
                {this.props.additional_options}
            </Select>
        )
    }

    componentDidMount(){
        // console.log("mounted")
        if(this.props.send_params){
            console.log("for send params",this.props)
            console.log("DID MOUNT ",this.props.item.name, this.props.ext_params)
            let new_params={};
            if(Array.isArray(this.props.send_params_keys)){
                this.props.send_params_keys.map((k)=>{
                    new_params[k]=this.props.ext_params[k];
                });
            }else{
                new_params=this.props.ext_params
            }

            this.setState({
                prevParams:new_params
            })

            this.list_items.config({
                params:{
                    pagination:false,
                    ...new_params
                }
            }).execute()
        }else{
            console.log("for not send params",this.props)
        this.list_items.execute();
        }
    }


    // componentWillReceiveProps(nextProps){
    //     console.log("new props",nextProps.ext_params,this.props.ext_params)
    //     if(nextProps.ext_params!==this.props.ext_params){
    //       //Perform some operation
    //       console.log("new props changed",nextProps.ext_params)
    //     }    
    //   }

    componentDidUpdate (prevProps) {
        // lodash
        // console.log("props changed",this.props.ext_params,prevProps.ext_params,this.props)
        let ext_new_params={};
        let ext_old_params={};

        if(Array.isArray(this.props.send_params_keys)){
            this.props.send_params_keys.map((k)=>{
                ext_new_params[k]=this.props.ext_params[k];
                ext_old_params[k]=prevProps[k];
            });
        }else{
            ext_new_params=this.props.ext_params;
            ext_old_params=prevProps.ext_params;
        }

        console.log("compairing for ",this.props.item.name,ext_new_params,ext_old_params,this.state.prevParams);
        
        if(!lodash.isEqual(ext_new_params,ext_old_params)&&!lodash.isEqual(ext_new_params,this.state.prevParams)){
            console.log("compairing for not equal",this.props.item.name,ext_new_params,ext_old_params);
            this.setState({
                prevParams:ext_new_params
            })
            if(this.props.send_params){
                // this.setState({
                //     s:3
                // })
                this.list_items.config({
                    params:{
                    pagination:false,
                    ...ext_new_params
                    }
                }).execute();
            }
        }
        if(this.props.url!=prevProps.url){
            console.log("URL CHANGED");
            this.list_items.config({
                url:this.props.url
            }).execute()
        }
        // if (this.props.value !== prevProps.value && prevProps.value==null  && this.props.value !=null) {

            // do search initially by id for editing

            // console.log("search  for data")
            // fetch the new product based and set it to the state of the component
        // };
    }

}

export default  NetworkSelect=withDomains(NetworkSelect,"dynamic")
